import { 
    LOADING, 
    CONNECTION_SERVER, 
} from '../actions/types';

const initialState = {
    loading: false,
    connection: true,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING:
            return { ...state, loading: action.payload };
        case CONNECTION_SERVER:
            return { ...state, connection: action.payload };

        default:
            return state
    }
};
